// This file will contain all the colors we are using with guide on where it is used often
export const colors = {
  /**
   * #ECEFF4 Ice Gray
   */
  iceGray: '#ECEFF4',

  /**
   * #ede9e3 Light Gray
   */
  primary1: '#ede9e3',

  /*
   * #CACACA Gray
   */
  primary2: '#CACACA', // not used

  /**
   * #585858 Dark Gray
   */
  primary3: '#585858', // not used

  /**
   * #2b333d Dark Slate Blue
   */
  primary4: '#2b333d',

  /**
   * #191919 Soft Black
   */
  primary5: '#191919', // not used

  /**
   * #E55867 Red
   */
  accent4: '#E55867', // not used

  /**
   * #02bece Blue
   */
  links: '#02bece',

  /**
   * #0B3948 Deep Navy
   */
  navy: '#0B3948',

  /**
   * #E24657 Red
   */
  alert: '#E24657', // not used

  /**
   * #F4B25C Yellow
   */
  warning4: '#F4B25C', // not used

  /**
   * #4FD9C2 Green
   */
  // not used
  // green: '#4FD9C2',

  /**
   * #000000 Black
   */
  black: '#000000',

  /**
   * #ffffff White
   */
  white: '#ffffff',

  /**
   * #E6E6E6 Light Gray
   */
  whiteHover: '#E6E6E6', // not used

  /**
   * #F4F4F4  Light Gray
   */
  placeholder: '#F4F4F4', // not used

  /**
   * #F9F7D7 Light Yellow
   */
  highlight: '#F9F7D7', // not used

  whiteAlpha: {
    100: '#FFFFFF1A',
    200: '#FFFFFF33',
    300: '#FFFFFF4D',
    400: '#FFFFFF66',
    900: '#FFFFFFED',
  },

  blackAlpha: {
    100: '#0000001A',
    200: '#00000033',
    600: '#00000099',
  },

  primary: {
    25: '#fafafa',
    50: '#d6f5f0',
    100: '#98bed5', // used
    200: '#817e7e', // used
    300: '#333333', // used
  },

  gray: {
    // All used
    50: '#F9FAFB',
    100: '#F7FAFC',
    200: '#EDF2F7',
    300: '#E2E8F0',
    400: '#CBD5E0',
    500: '#A0AEC0',
    600: '#718096',
    700: '#2D3748',
    800: '#1A202C',
    900: '#171923',
  },

  slate: {
    50: '#f5f6f7',
    100: '#e9ebed',
    200: '#8d9da7', // used
    250: '#303c40', // used
    300: '#2b333d', // used
    400: '#1f252d',
    500: '#161b21',
    600: '#0d1115',
  },

  success: {
    50: '#d6f5f0',
    100: '#98e6d6',
    200: '#3bd5bb',
    300: '#4FD9C2',
    400: '#3bd5bb',
    500: '#3bd5bb',
    600: '#2EA692',
    700: '#00825c',
    800: '#00724d',
    900: '#005530',
  },

  accent: {
    50: '#fceaee',
    100: '#f8cad3',
    200: '#E55867',
    300: '#E55867',
    400: '#E24657',
    500: '#E24657',
    600: '#d8253f',
    700: '#c61a38',
    800: '#b91231',
    900: '#aa0026',
  },

  warning: {
    50: '#FDF0DE',
    100: '#F4B25C',
    200: '#BF7F2C',
  },

  blue: {
    300: '#63B3ED',
    400: '#4299E1',
    500: '#3182CE',
    600: '#2B6CB0',
    800: '#2C5282',
  },

  teal: {
    400: '#38B2AC',
    500: '#319795',
    600: '#2C7A7B',
  },

  red: {
    300: '#FC8181',
    500: '#E53E3E',
    700: '#9B2C2C',
  },

  green: {
    400: '#48BB78',
    500: '#38A169',
    600: '#2F855A',
    800: '#22543D',
  },

  yellow: {
    400: '#F6E05E',
  },
}
